import { Collaborator, TrackFile, TrackFileTypeMap } from "../../proto/api_pb";

export interface TrackFilesProps {
  url: string;
  label: string;
  timeStamp: number;
  ownerId: string;
  fileType: TrackFileTypeMap[keyof TrackFileTypeMap];
  fileName: string;
  fileSize: string;
  handleOpenDeleteModal?: (id: string) => void;
  handleOpenCollabsModal?: (id: string) => void;
  fileId?: string;
  collaborators: Collaborator[];
  file: TrackFile;
}

export interface FileObj {
  trackFile: TrackFile;
  fileSize: number;
}

export const month = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const FileTypeMap: Record<number, string> = {
  0: "Unspecified",
  1: "Other",
  2: "Session",
  3: "Stem Vocal",
  4: "Stem Drum",
  7: "Stem Melody",
  8: "Stem Instrument",
  9: "Stem Baseline",
  10: "Lyrics",
  11: "Artwork",
};

export const defaultProfilePhoto =
  "https://png.pngtree.com/png-vector/20191110/ourmid/pngtree-avatar-icon-profile-icon-member-login-vector-isolated-png-image_1978396.jpg";
